<script setup lang="ts">
import {OrderContentType, OrderIndex} from "@/order/interfaces/Order";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import SecureImage from "@/core/components/secure-image/SecureImage.vue";
import {computed} from "vue";
import dayjs from "dayjs";
import OrderService from "@/order/services/OrderService";
import OrderPaidOnlineBadge from "@/order/components/OrderPaidOnlineBadge.vue";

const props = defineProps<{
    order: OrderIndex;
    showCustomerName?: boolean;
}>();

const orderFiles = computed(() => {
    return props.order.orderable?.prescription?.files;
});

const subtitle = computed(() => {
    const orderDate = `Le ${dayjs(props.order.created_at).format('DD/MM/YYYY')}`;

    if (props.order.content_type !== OrderContentType.CART) {
        let subtitle = orderDate + ' - Ordonnance';
        if (props.order.prescriptor?.last_name) {
            subtitle += ` du DR. ${props.order.prescriptor?.last_name}`;
        }
        if (props.order.content_type !== OrderContentType.RENEWAL) {
            subtitle += ' envoyée pour renouvellement';
        }

        return subtitle;
    }

    const count = props.order.orderable.items_count ?? props.order.orderable.products_count ?? 0;

    return count === 0 || count ? orderDate + ` - ${count} produits` : orderDate;
});
</script>

<template>
  <BaseCard>
    <BaseCardBody>
      <div class="flex">
        <div v-if="order.content_type !== OrderContentType.CART" class="w-24 h-24">
          <SecureImage v-if="orderFiles" :urls="orderFiles" :size="16" />
        </div>
        <div v-else class="w-24 h-24">
          <img src="@/assets/icons/cart-bubble.svg" class="h-24 w-24" alt="cart bubble">
        </div>
        <div class="flex justify-between align-center ml-4">
          <div>
            <p v-if="showCustomerName" class="font-medium">
              {{ order.customer.information.name }}
            </p>
            <p>{{ order.content_type === OrderContentType.CART ? 'Click & Collect' : 'Ordonnance' }}</p>
            <p class="text-sm">
              {{ subtitle }}
            </p>
            <div class="flex flex-row items-center gap-2 mt-2">
              <v-chip
                :color="OrderService.statusColor(order)"
                small
              >
                <p class="text-sm">
                  {{ OrderService.statusLabel(order) }}
                </p>
              </v-chip>
              <OrderPaidOnlineBadge v-if="OrderService.isPaidOnline(order)" />
            </div>
          </div>
        </div>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<style scoped>

</style>
